import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-heading-c-up-proposal')
export class ObiHeadingCUpProposal extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M17 7L12 1L7 7H17Z" fill="currentColor"/>
<path d="M11.7875 11.624C12.1609 11.4427 12.5822 11.352 13.0515 11.352C13.4782 11.352 13.9049 11.4267 14.3315 11.576C14.7689 11.7147 15.1955 11.8853 15.6115 12.088L16.3795 10.2C15.8675 9.95468 15.3235 9.76268 14.7475 9.62402C14.1822 9.48535 13.6169 9.41602 13.0515 9.41602C12.1875 9.41602 11.4195 9.56002 10.7475 9.84802C10.0862 10.136 9.5262 10.5413 9.06754 11.064C8.60887 11.5867 8.2622 12.2107 8.02754 12.936C7.79287 13.6507 7.67554 14.44 7.67554 15.304C7.67554 16.4774 7.85687 17.5067 8.21954 18.392C8.59287 19.2667 9.1582 19.9493 9.91554 20.44C10.6835 20.92 11.6542 21.16 12.8275 21.16C13.4355 21.16 13.9849 21.112 14.4755 21.016C14.9662 20.92 15.4569 20.776 15.9475 20.584V18.632C15.4142 18.824 14.9129 18.9733 14.4435 19.08C13.9849 19.176 13.5209 19.224 13.0515 19.224C12.3689 19.224 11.8035 19.0747 11.3555 18.776C10.9075 18.4667 10.5769 18.0187 10.3635 17.432C10.1609 16.8454 10.0595 16.1413 10.0595 15.32C10.0595 14.712 10.1235 14.1627 10.2515 13.672C10.3902 13.1813 10.5875 12.7653 10.8435 12.424C11.0995 12.072 11.4142 11.8053 11.7875 11.624Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 7L12 1L7 7H17Z" style="fill: var(--element-active-color)"/>
<path d="M11.7875 11.624C12.1609 11.4427 12.5822 11.352 13.0515 11.352C13.4782 11.352 13.9049 11.4267 14.3315 11.576C14.7689 11.7147 15.1955 11.8853 15.6115 12.088L16.3795 10.2C15.8675 9.95468 15.3235 9.76268 14.7475 9.62402C14.1822 9.48535 13.6169 9.41602 13.0515 9.41602C12.1875 9.41602 11.4195 9.56002 10.7475 9.84802C10.0862 10.136 9.5262 10.5413 9.06754 11.064C8.60887 11.5867 8.2622 12.2107 8.02754 12.936C7.79287 13.6507 7.67554 14.44 7.67554 15.304C7.67554 16.4774 7.85687 17.5067 8.21954 18.392C8.59287 19.2667 9.1582 19.9493 9.91554 20.44C10.6835 20.92 11.6542 21.16 12.8275 21.16C13.4355 21.16 13.9849 21.112 14.4755 21.016C14.9662 20.92 15.4569 20.776 15.9475 20.584V18.632C15.4142 18.824 14.9129 18.9733 14.4435 19.08C13.9849 19.176 13.5209 19.224 13.0515 19.224C12.3689 19.224 11.8035 19.0747 11.3555 18.776C10.9075 18.4667 10.5769 18.0187 10.3635 17.432C10.1609 16.8454 10.0595 16.1413 10.0595 15.32C10.0595 14.712 10.1235 14.1627 10.2515 13.672C10.3902 13.1813 10.5875 12.7653 10.8435 12.424C11.0995 12.072 11.4142 11.8053 11.7875 11.624Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-heading-c-up-proposal': ObiHeadingCUpProposal;
  }
}
